export default "__VITE_ASSET__R5bEHl$O__"